// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import axios from "axios"
import App from "./App.vue"
import configs from "@/config"
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import { parseTime, resetForm } from "@/utils/index.js";

Vue.use(ElementUI, { size: "small" })
Vue.use(Viewer)
import router from "./router"
axios.defaults.baseURL = configs.baseUrl
Vue.config.productionTip = false
axios.defaults.withCredentials = true

// 全局方法挂载
Vue.prototype.resetForm = resetForm;
Vue.prototype.parseTime = parseTime;
Vue.prototype.openLoading = openLoading

Vue.filter("formTime", function(v) {
  if (v == 0 || !v) {
    return "暂无"
  }
  let t = new Date(parseInt(v))
  return (
    t.toLocaleDateString().replace(/\//g, "-") +
    " " +
    t.toTimeString().substr(0, 8)
  )
})
Viewer.setDefaults({
  Options: {
    'inline': true, //启用lnline模式
    'button': true, //显示右上角关闭按钮
    'navbar': true, //显示缩略图导航
    'title': true, //显示当前图片的标题
    'toolbar': true, //显示工具栏
    'tooltip': true, //显示缩放百分比
    'movable': true, //显示可移动
    'zoomable': true, //图片是否可缩放
    'rotatable': true, //图片是否可旋转
    'scalable': true, //图片是否可翻转
    'transition': true, //使用css3过度
    'fullscreen': true, //播放时是否全屏
    'keyboard': true, //是否支持键盘
    'url': 'data-source' //设置大图片的url
  }
})
// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    let token = sessionStorage.token_admin
    config.headers.common["token"] = token
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function(res) {
    if (res.data.errorCode == 405) {
      sessionStorage.clear()
      router.push("/login")
    }
    if(res.data.errorCode == 406){
      alert(res.data.info)
    }
    return res
  },
  function(err) {
    return Promise.reject(err)
  }
)

// // 添加响应拦截器
// axios.interceptors.response.use(function (res) {
//   if (res.data.code == 666666) {
//     router.push({
//       path: "login"
//     })
//     return
//   }
//   if (res.data.status !== 1) {
//     ElementUI.Message.error(res.data.msg);
//     return;
//   }
//   // let tableWrap = document.querySelectorAll(".el-table__body-wrapper");
//   // if (tableWrap.length >= 1) {
//   //   let tableScroll = tableWrap[0];
//   //   tableScroll.scrollTop = 0;
//   // }
//   return res;
// }, function (error) {
//   // 对响应错误做点什么
//   return Promise.reject(error);
// });
Vue.prototype.$axios = axios

Vue.directive('enterNextInput', {
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
      if(charcode == 13){
        var dom = document.getElementsByTagName("input")
        console.log(dom)
        for (var i = 0; i < dom.length; i++) {
          if (dom[i] == document.activeElement) {
            if (i == dom.length) {
              return
            }
            if (dom[i + 1].disabled) {
              dom[i + 2].focus()
            } else {
              dom[i + 1].focus()
            }
            return
          }
        }
      }
    });
  }
});
Vue.prototype.jquery = function (id) {
  return document.getElementById(id);
};
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
})

export function openLoading(msg) {
  const loading = this.$loading({ // 声明一个loading对象
    lock: true, // 是否锁屏
    text: msg, // 加载动画的文字
    spinner: 'el-icon-loading', // 引入的loading图标
    background: 'rgba(0, 0, 0, 0.7)' // 背景颜色
  })
  return loading
}



// WEBPACK FOOTER //
// ./src/main.js